import React from 'react'
import View from '../../../../../../components/pdf/View'
import Text from '../../../../../../components/pdf/Text'
import Separator from '../../../../../../components/pdf/Separator'
import { Table, TableCol, TableRow } from '../../../../../../components/pdf/Table'
import { getNPCellColor } from '../../../_helpers/pdfHelpers'

const OrganizationalTable = ({ categorizedReplies }) => {
  return (
    <View>
      <Table width={'100%'} useFontBaseColor style={{ marginTop: '-1px' }}>
        <TableRow useFontBaseColor bgColor={'#e2e2e2'}>
          <TableCol colspan="5" useFontBaseColor>
            <Text bold align={'center'}>
              FATORES DE RISCO ORGANIZACIONAIS
            </Text>
          </TableCol>
        </TableRow>
        <TableRow useFontBaseColor bgColor={'#e2e2e2'}>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              NP
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Fator de Risco identificado
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Setor
            </Text>
          </TableCol>
          <TableCol useFontBaseColor>
            <Text bold align={'center'}>
              Funções
            </Text>
          </TableCol>
          <TableCol useFontBaseColor width="45%">
            <Text bold align={'center'}>
              Sugestões para redução ou eliminação do risco
            </Text>
          </TableCol>
        </TableRow>
        {categorizedReplies.organizacaoTrabalho.map(item => {
          return (
            <>
              <TableRow useFontBaseColor>
                <TableCol bgColor={getNPCellColor(item.np)} useFontBaseColor>
                  <Text bold align={'center'}>
                    {item.np}
                  </Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align={'center'}>{item.questionReply}</Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align={'center'}>{item.department}</Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text align={'center'}>{item.role}</Text>
                </TableCol>
                <TableCol useFontBaseColor>
                  <Text>{item.suggestionReply}</Text>
                </TableCol>
              </TableRow>
            </>
          )
        })}
      </Table>
      <Separator weight={10} />
    </View>
  )
}

export default OrganizationalTable
